<div class="pagination-position" id="pagination-height">
  <div class="card mb-0">
    <div class="card-body container-fluid">
      <div class="row justify-content-md-between align-items-md-center g-0 pagination">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info text-start" id="tickets-table_info" aria-live="polite">
            {{ "label-title.showing" | translate }}
            {{ paginationService.startIndex }} {{ "label-title.to" | translate | lowercase }} {{ paginationService.endIndex }} {{ "label-title.of" | translate | lowercase }}
            {{ paginationService.dataLength }}
            {{ "label-title.entries" | translate | lowercase }}
          </div>
        </div>
        <!-- Pagination -->
        <div class="col-sm-12 col-md-6">
          <div class="text-md-right float-md-end pagination-rounded gridjs-pagination">
            <pagination-controls (pageChange)="paginationService.onPageChange($event)" [responsive]="true" [maxSize]="5"></pagination-controls>
          </div>
        </div>
        <!-- End Pagination -->
      </div>
    </div>
  </div>
</div>
